import React from "react";
import { PageHeader } from "@/components/PageHeader";
import { CtaButton } from "@/components/CtaButton";

export default function NotFoundPage() {
    return (
        <div>
            <PageHeader
                eyebrow="404"
                title="This page can’t be found"
                subtitle="It may have moved or never existed. Head back home or explore another corner of the practice."
                breadcrumbs={[{ label: "Home", to: "/" }, { label: "Not found" }]}
            >
                <div className="flex flex-wrap gap-3">
                    <CtaButton to="/">Back to home</CtaButton>
                    <CtaButton to="/treatments" variant="secondary">
                        Browse treatments
                    </CtaButton>
                </div>
            </PageHeader>
        </div>
    );
}
